import { useQuery } from 'react-query'

import { zervantSettingsQueryKey } from '../constants/zervantSettingsQueryKey'
import { fetchZervantSettings } from '../query-api'

type UseZervantSettingsProps = {
  enabled?: boolean
}

export const useZervantSettings = ({ enabled = true }: UseZervantSettingsProps = {}) => {
  const {
    data: settingsData,
    isError,
    ...rest
  } = useQuery(zervantSettingsQueryKey, () => fetchZervantSettings(), {
    enabled,
  })

  // A failed refetch keeps the last document, so hasFailedToLoad stays false once settings have loaded.
  const hasFailedToLoad = isError && !settingsData

  return { data: settingsData?.data, hasFailedToLoad, isError, ...rest }
}
